module.exports = __webpack_public_path__ + "img/logo-two-lines.dfaf9fef.svg";